import { ComponentPropsWithoutRef, PropsWithChildren } from 'react';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

interface HelpCardProps extends ComponentPropsWithoutRef<'div'> {}
const HelpCard = ({ className, ...restProps }: HelpCardProps) => {
    return (
        <div
            className={twMerge(
                'bg-gray-25 flex h-full flex-col gap-2 rounded-lg border border-gray-100 p-4',
                className,
            )}
            {...restProps}
        />
    );
};

interface HelpCardBodyProps extends ComponentPropsWithoutRef<'p'> {}
const HelpCardBody = ({ className, ...restProps }: HelpCardBodyProps) => {
    return <p className={twMerge('text-sm text-gray-700', className)} {...restProps} />;
};

interface HelpCardIconProps extends ComponentPropsWithoutRef<'div'> {}
const HelpCardIcon = ({ className, ...restProps }: HelpCardIconProps) => {
    return (
        <div
            className={twMerge(
                '[&>svg]:text-brand-butter-primary size-6 [&>svg]:size-full',
                className,
            )}
            {...restProps}
        />
    );
};

interface HelpCardTitleProps extends ComponentPropsWithoutRef<'p'> {}
const HelpCardTitle = ({ className, ...restProps }: HelpCardTitleProps) => (
    <p className={twMerge('font-medium', className)} {...restProps} />
);

interface HelpCardFooterIconProps extends PropsWithChildren {}
const HelpCardFooterIcon = (props: HelpCardFooterIconProps) => {
    const { children = <FontAwesomeIcon icon={faArrowRight} /> } = props;
    return <>{children}</>;
};

interface HelpCardFooterProps extends ComponentPropsWithoutRef<'div'> {}
const HelpCardFooter = (props: HelpCardFooterProps) => {
    const { className, ...restProps } = props;
    return (
        <div
            className={twMerge(
                'flex gap-2 self-end text-sm font-medium leading-4 [&>*]:flex [&>*]:gap-2',
                className,
            )}
            {...restProps}
        />
    );
};

const Root = HelpCard;
const Icon = HelpCardIcon;
const Title = HelpCardTitle;
const Body = HelpCardBody;
const Footer = HelpCardFooter;
const FooterIcon = HelpCardFooterIcon;

export {
    HelpCard,
    HelpCardIcon,
    HelpCardTitle,
    HelpCardBody,
    HelpCardFooter,
    HelpCardFooterIcon,
    //
    Root,
    Icon,
    Title,
    Body,
    Footer,
    FooterIcon,
};
export type { HelpCardIconProps, HelpCardTitleProps, HelpCardFooterProps };
